import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { NoticeLoading } from '@fs/zion-icon'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { userDelayMs } from '../../constants'
import { visuallyHiddenCss } from '../../css'

const spinnerCss = css`
  margin: 20px;
`

const RequestStatus = ({ loading, invisible }) => {
  const { t } = useTranslation()
  const [delayedLoading, setDelayedLoading] = useState(false)
  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => setDelayedLoading(loading), userDelayMs)
      return () => clearTimeout(timeout)
    }
    return setDelayedLoading(loading)
  }, [loading])
  return (
    <div role="status" aria-live="polite">
      {delayedLoading && !invisible && (
        <div css={spinnerCss}>
          <NoticeLoading />
        </div>
      )}
      {delayedLoading && <span css={visuallyHiddenCss}>{t('common-ui:loading.ellipsis.label', 'Loading...')}</span>}
    </div>
  )
}

RequestStatus.propTypes = {
  loading: PropTypes.bool,
  invisible: PropTypes.bool,
}

export default RequestStatus
